import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const IdXboxIntroPage = loadable(() =>
  withDefaultLoaderModifiers(import("./IdXboxIntroPage"))
);
